// src/hooks/useTickerAutocomplete.js
// TICKER-SEARCH-AUTOCOMPLETE — new file.
// Generic — reusable anywhere a ticker/company search box is needed.

import { useState, useEffect, useRef } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const DEBOUNCE_MS = 250;

export function useTickerAutocomplete(query, limit = 8) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (!query || !query.trim()) { setSuggestions([]); setLoading(false); return; }

    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      let cancelled = false;
      setLoading(true);
      fetch(API_URL + '/api/search/tickers?q=' + encodeURIComponent(query) + '&limit=' + limit)
        .then(r => r.json())
        .then(d => { if (!cancelled) setSuggestions(d.success ? (d.suggestions || []) : []); })
        .catch(() => { if (!cancelled) setSuggestions([]); })
        .finally(() => { if (!cancelled) setLoading(false); });
      return () => { cancelled = true; };
    }, DEBOUNCE_MS);

    return () => { if (debounceRef.current) clearTimeout(debounceRef.current); };
  }, [query, limit]);

  return { suggestions, loading };
}
